import fetchWithTimeout from './fetch';

const storageKey = 'storeTheme';

export type SkuInfoType = {
  name: string;
  image: string;
  categoriesIds: string[];
  categoriesNames: string[];
  url: string;
  variations: string;
  complementName: string;
  addToCartLink: string;
  price: string;
  customMeasureType?: string;
  customMeasureTypeClean?: string;
  productClusters?: Record<string, string>;
  customMeasureValue?: string;
  available: boolean;
  'Preco Swift'?: string;
};

export type GetSkuInfoByProductListOptions = {
  useFqFilterProducts?: boolean;
};

/**
 * Busca informações do produto na API de busca pra poder apresentar mais detalhes no conteúdo de favoritos
 */
const getSkuInfoByProductList = async (
  idList: string[],
  type: 'skuId' | 'productId',
  options: GetSkuInfoByProductListOptions = {
    useFqFilterProducts: true,
  },
): Promise<Record<string, SkuInfoType>> => {
  const idsToSearch = idList.reduce((stack, sId) => {
    let info = window.storeTheme.helpers.storage.read(`${storageKey}-${type}-${sId}`);
    if (!info) {
      stack.push(sId);
    }
    return stack;
  }, []);

  var handleError = function (err) {
    console.error(err);
    return new Response(
      JSON.stringify({
        code: 400,
        message: 'Error',
      }),
    );
  };

  if (idsToSearch.length) {
    try {
      const response = await fetchWithTimeout(
        `/api/catalog_system/pub/products/search/?${idsToSearch.map((i) => `fq=${type}:${i}`).join('&')}&${
          options.useFqFilterProducts ? 'fq=specificationFilter_107:Produtos&' : ''
        }sc=${window.storeTheme.salesChannelSelector.getSalesChannel()}&O=OrderByTopSaleDESC`,
      ).catch(handleError);

      if (response.ok) {
        await response.json().then(async (products) => {
          if (!Array.isArray(products)) {
            return [];
          }

          for (const prod of products) {
            const { items, ...productData } = prod;
            if (type === 'productId') {
              const itemIds = items.map(({ itemId }) => itemId);
              window.storeTheme.helpers.storage.save(
                `${storageKey}-${type}-${prod.productId}`,
                { ...productData, items: itemIds },
                3,
              );
            }

            for (const sku of items) {
              const seller = (sku?.sellers || []).find((s) => s.sellerDefault);
              const price = seller?.commertialOffer?.Price || '';
              const available = seller?.commertialOffer?.AvailableQuantity > 0;
              const variations = sku?.variations
                ?.map((variation) => {
                  return sku?.[variation]?.[0];
                })
                .join(', ');

              const skuInfo: SkuInfoType = {
                name: sku.name,
                image: sku.images[0].imageUrl,
                url: prod.link.split(window.location.hostname).reverse()?.[0],
                variations,
                complementName: sku.complementName,
                addToCartLink: '/checkout/' + (seller?.addToCartLink ?? '#').split('/checkout/')?.reverse()?.[0],
                price: window.storeTheme.helpers.format.money(price),
                customMeasureType: prod?.['Unidade de Medidas']?.[0],
                customMeasureTypeClean: window.storeTheme.helpers.text.kebabCase(
                  (prod?.['Unidade de Medidas'] || [])?.[0] || '',
                ),
                customMeasureValue: prod?.['Quantidade dentro da unidade de medida']?.[0],
                available,
                categoriesIds: prod?.categoriesIds?.[0].split('/').filter((c) => !!c),
                categoriesNames: prod?.categories?.[0].split('/').filter((c) => !!c),
                productClusters: prod?.productClusters,
                'Preco Swift': prod?.['Preco Swift'],
              };

              window.storeTheme.helpers.storage.save(`${storageKey}-${type}-${sku.itemId}`, skuInfo, 3);
            }
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  const result = idList.reduce((stack, sId) => {
    let prodInfo = {};
    let consult = sId;

    if (type === 'productId') {
      prodInfo = window.storeTheme.helpers.storage.read(`${storageKey}-${type}-${sId}`);
      consult = prodInfo?.['items']?.[0];
    }

    const info = window.storeTheme.helpers.storage.read(`${storageKey}-${type}-${consult}`);

    if (info) {
      Object.assign(stack, { [sId]: info });
    }
    return stack;
  }, {});

  return result;
};

const getShelfItemsHtml = async (skuIds: (number | string)[], { templateId }) => {
  if (!templateId) {
    return false;
  }

  const url = `/buscapagina?PS=50&sl=${templateId}&cc=48&sm=0&PageNumber=1&${skuIds
    .map((sku) => `fq=skuId:${sku}`)
    .join('&')}`;
  try {
    const response = await fetchWithTimeout(url);
    if (response.ok && response.text) {
      return await response.text();
    }
  } catch (e) {
    return '';
  }
};

window.storeTheme = window.storeTheme || ({} as StoreTheme);

Object.assign(window.storeTheme, {
  helpers: Object.assign(window.storeTheme.helpers || {}, {
    getSkuInfoByProductList,
    getShelfItemsHtml,
  }),
});

export default {};
